import { RegistrationState } from "./RegistrationState";

/** Etat : Redirection de l'utilisateur après 5 seconde */
export class RegStateRedirect extends RegistrationState{
    public async Next(): Promise<void> {
        setTimeout(async () =>{
            await this.context.$store.dispatch("HideLoadingMask", {});
            await this.context.$router.push({ name: 'Connexion' });
        }, 5000);
    }
}